<script>
export default {
  name: 'account.profile.preferences'
}
</script>
<template>
  <b-card>
    preferences info
  </b-card>
</template>
